import extractMainColors from './extractMainColors';

/**
 * Extracts colors from the empty state image
 * Used when no image is uploaded or when image is removed
 */
export const extractEmptyStateColors = async () => {
  try {
    const response = await fetch('/emptyState.png');
    const blob = await response.blob();
    return await extractMainColors(blob);
  } catch (err) {
    console.error('Failed to extract colors from emptyState:', err);
    throw err;
  }
};

